// extracted by mini-css-extract-plugin
module.exports = {"root":"WebhookLogs_root__1Z6DT","item":"WebhookLogs_item__1hOCZ","col":"WebhookLogs_col__31HN7","sideCol":"WebhookLogs_sideCol__2cqNN","button":"WebhookLogs_button__3Wlm2"};